import { HealthPill } from "./AppHeader";
import { SectionTabs } from "@features/dashboard/ui/SectionTabs";
import { RANGE_SECONDS } from "@features/dashboard/model/range";
import type { HealthResponse } from "@shared/api";
import type { RangeKey, SectionKey } from "@features/dashboard/model/types";
import styles from "./AppToolbar.module.css";

interface AppToolbarProps {
  activeSection: SectionKey;
  health: HealthResponse | null;
  newMatchNoticeCount: number;
  range: RangeKey;
  onChangeSection: (section: SectionKey) => void;
  onChangeRange: (range: RangeKey) => void;
}

export function AppToolbar({
  activeSection,
  health,
  newMatchNoticeCount,
  range,
  onChangeSection,
  onChangeRange,
}: AppToolbarProps) {
  return (
    <div className={styles.toolbar}>
      <SectionTabs active={activeSection} newCount={newMatchNoticeCount} onChange={onChangeSection} />
      <div className={styles.right}>
        {health && <HealthPill health={health} />}
        <div className={styles.rangeSwitcher} role="group" aria-label="Time range">
          {(Object.keys(RANGE_SECONDS) as RangeKey[]).map((key) => (
            <button
              key={key}
              className={[styles.rangeButton, key === range ? styles.rangeButtonActive : ""].filter(Boolean).join(" ")}
              onClick={() => onChangeRange(key)}
            >
              {key}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
